import React, { useState } from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Link } from "react-router-dom";
import Ann2026 from "./Ann2026";
import Ann2025 from "./Ann2025";
import Ann2024 from "./Ann2024";
import Ann2023 from "./Ann2023";
import Ann2022 from "./Ann2022";
import Ann2021 from "./Ann2021";

import { Container, Row } from "react-bootstrap";

export function AnnouncementTable({ announcementsArray }) {
    return (
        <section
            className="event event03 p-relative fix"
            style={{ background: "#f7f9ff", padding: "10px" }}
        >
            <div
                className="col-md-12  wow fadeInUp animated"
                data-animation="fadeInUp"
                data-delay=".4s"
            >
                <div className="newspaper scrollbar3">
                    {announcementsArray.map((announcement, index) => (
                        <div
                            className="event-item mb-10 hover-zoomin"
                            key={index}
                        >
                            <div className="event-content">
                                <div className="icon">
                                    <i className="fas fa-bullhorn" />
                                </div>
                                <div
                                    className="text"
                                    style={{ textAlign: "left" }}
                                >
                                    <h6>
                                        <Link to={announcement.link} target="_blank">
                                            {announcement.title} 
                                        </Link>
                                        
                                        <div className="d-flex">
                                            {announcement.notifyLink && 
                                                <Link target="_blank" className=" btn-small" to={announcement.notifyLink}>Notification</Link>
                                            }
                                            {announcement.appLink && 
                                                <Link target="_blank" className=" btn-small" to={announcement.appLink}>Application Form</Link>
                                            }
                                            {announcement.eligibilityLink && 
                                                <Link target="_blank" className=" btn-small" to={announcement.eligibilityLink}>Eligibility & Apply Link</Link>
                                            }
                                             {announcement.shortLink && 
                                                <Link target="_blank" className=" btn-small" to={announcement.shortLink}>Shortlisted List</Link>
                                            }
                                             {announcement.syllabusLink && 
                                                <Link target="_blank" className=" btn-small" to={announcement.syllabusLink}>Syllabus</Link>
                                            }
                                            {announcement.schemeLink && 
                                                <Link target="_blank" className=" btn-small" to={announcement.schemeLink}>Schemes</Link>
                                            }
                                            {announcement.guideLink && 
                                                <Link target="_blank" className=" btn-small" to={announcement.guideLink}>Guidelines</Link>
                                            }
                                            {announcement.userLink && 
                                                <Link target="_blank" className=" btn-small" to={announcement.userLink}>User manual</Link>
                                            }
                                        </div>
                                    </h6>
                                    
                                    
                                </div>
                            </div>
                            
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

function Main() {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleToggle = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const faqData = [

        {
            id: "announcementYr2026",
            question: "2026 - Announcements",
            answer: <AnnouncementTable announcementsArray={Ann2026} />,
        },

        {
            id: "announcementYr2025",
            question: "2025 - Announcements",
            answer: <AnnouncementTable announcementsArray={Ann2025} />,
        },

        {
            id: "announcementYr2024",
            question: "2024 - Announcements",
            answer: <AnnouncementTable announcementsArray={Ann2024} />,
        },

        {
            id: "announcementYr2023",
            question: "2023 - Announcements",
            answer: <AnnouncementTable announcementsArray={Ann2023} />,
        },
        {
            id: "announcementYr2022",
            question: "2022 - Announcements",
            answer: <AnnouncementTable announcementsArray={Ann2022} />,
        },
        {
            id: "announcementYr2021",
            question: "2021 - Announcements",
            answer: <AnnouncementTable announcementsArray={Ann2021} />,
        },
    ];

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Announcements" />
            <section className="project-detail">
                <Container>
                    <Row>
                        <div className="c-heading mb-5">
                            <h1>Announcements</h1>
                        </div>

                        <div
                            className="col-lg-12 col-md-12 text-center wow fadeInUp animated"
                            data-animation="fadeInUp"
                            data-delay=".4s"
                        >
                            <div
                                className="faq-wrap pl-30 wow fadeInUp animated"
                                data-animation="fadeInUp"
                                data-delay=".4s"
                            >
                                <div
                                    className="accordion"
                                    id="accordionExample"
                                >
                                    {faqData.map((item, index) => (
                                        <div className="card" key={index}>
                                            <div
                                                className="card-header"
                                                id={item.id}
                                            >
                                                <h2 className="mb-0">
                                                    <button
                                                        className={`faq-btn${
                                                            activeIndex ===
                                                            index
                                                                ? ""
                                                                : " collapsed"
                                                        }`}
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse${index}`}
                                                        onClick={() =>
                                                            handleToggle(index)
                                                        }
                                                    >
                                                        {item.question}
                                                    </button>
                                                </h2>
                                            </div>
                                            <div
                                                id={`collapse${index}`}
                                                className={`collapse${
                                                    activeIndex === index
                                                        ? " show"
                                                        : ""
                                                } lower-content`}
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="card-body">
                                                    {item.answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Main;
